module.exports = __webpack_public_path__ + "static/media/roundaboutCW45.018038ce.svg";